import { ServiceUrlsProvider } from '@ori/configuration-manager';
import { ClientCultureProvider } from '@ori/culture';
import { EnvironmentProvider } from '@ori/environment';
import { TranslationsProvider } from '@ori/i18n';
import { ApiProvider, MiniShoppingBagController } from '@ori/mini-shopping-bag';
import { jsx as _jsx } from "react/jsx-runtime";
export const App = ({
  currentLanguage,
  staticApiUrl,
  tenant
}) => /*#__PURE__*/_jsx(ServiceUrlsProvider, {
  serviceUrls: {
    staticApiUrl
  },
  children: /*#__PURE__*/_jsx(EnvironmentProvider, {
    tenant: tenant,
    children: /*#__PURE__*/_jsx(TranslationsProvider, {
      defaultTranslationsWithNamespaces: {},
      language: currentLanguage,
      translationsWithNamespaces: {},
      children: /*#__PURE__*/_jsx(ApiProvider, {
        children: /*#__PURE__*/_jsx(ClientCultureProvider, {
          language: currentLanguage,
          tenant: tenant,
          options: {
            swr: {
              suspense: false
            }
          },
          children: /*#__PURE__*/_jsx(MiniShoppingBagController, {
            useOpenedMinibagOnDesktop: false
          })
        })
      })
    })
  })
});